import bem from 'utils/bem';

export const HANDLED_MESSAGE_FILE_ERR_CODES = ['IN006', 'IN008'];

export const block = bem('export-form');
